import { useTheme } from '@ytl/common-web';
import { useLayoutEffect } from 'react';
import { YeppFlowWebView } from '../modules/yepp/YeppFlowWebView';

export enum YeppFlowPhase {
  RegisterForm = 'registerForm',
  RegisterWrongEmail = 'registerWrongEmail',
  RegisterAlreadyRegistered = 'registerAlreadyRegistered',
  EmailVerification = 'emailVerification',
  PhoneNumberVerificationCA = 'phoneNumberVerificationCA',
  PhoneNumberVerificationOther = 'phoneNumberVerificationOther',
  PhoneNumberVerificationCode = 'phoneNumberVerificationCode',
  Finish = 'finish',
  Banned = 'banned',
  Error = 'error',
}

export const YeppFlowPage = () => {
  const { isWebView } = useTheme();

  useLayoutEffect(() => {
    document.documentElement.classList.add('register-page');
    if (isWebView) {
      document.documentElement.classList.add('ytl--app');
    }
    return () => {
      document.documentElement.classList.remove('register-page');
      document.documentElement.classList.remove('ytl--app');
    };
  }, [isWebView]);

  return (
    <>
      {isWebView && <YeppFlowWebView />}
      {!isWebView && <YeppFlowWebView />}
    </>
  );
};
